






















































import Vue from "vue";
// import VuexTest from "@/components/VuexTest.vue";
import LeaderboardGrid from "@/game/LeaderboardGrid.vue";
// import Trophy from "@/components/svg-img/Trophy.vue";
import { Actions } from "../store/leaderboard";
export default Vue.extend({
  components: {
    LeaderboardGrid
    // Trophy
  },
  data() {
    return {
      loading: false,
      err: false,
      isDev: process.env.NODE_ENV == "development"
    };
  },
  computed: {
    highscores() {
      return this.$store.getters["leaderboard/combined"];
      // return this.$store.state.leaderboard.users;
    }
  },
  activated() {
    this.loadScores();
  },
  methods: {
    async loadScores() {
      this.loading = true;
      try {
        await this.$store.dispatch(`leaderboard/${Actions.FETCH}`);
      } catch (err) {
        this.err = true;
        console.log("An error occured.");
      }
      this.loading = false;
    }
  }
});
